import script from "./BaseProcessComponent.vue?vue&type=script&lang=ts"
export * from "./BaseProcessComponent.vue?vue&type=script&lang=ts"

import "./BaseProcessComponent.vue?vue&type=style&index=0&id=3f181ac7&lang=css"
import "./BaseProcessComponent.vue?vue&type=style&index=1&id=3f181ac7&lang=scss"

const __exports__ = script;

export default __exports__